<script setup lang="ts">
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
import { showUnsavedDialog, cancelLeave, proceedLeave } from '@/composables/useUnsavedDialog'

const { t } = useI18n()
</script>

<template>
 <Modal
  :open="showUnsavedDialog"
  :title="t('common.unsaved_changes_title')"
  :ok-text="t('common.unsaved_changes_proceed')"
  :cancel-text="t('common.unsaved_changes_cancel')"
  @cancel="cancelLeave"
  @ok="proceedLeave"
 >
  <div class="crm-confirm-content">
   <ExclamationCircleOutlined class="crm-confirm-content__icon crm-confirm-content__icon--warning" />
   <p>{{ t('common.unsaved_changes_warning') }}</p>
  </div>
 </Modal>
</template>
